module.exports = new __parcel__URL__("next-gen-backlog-app-skeleton.tpl.28e29051.svg").toString();